import { createReducer, createSetter } from "@/redux/helpers/reducer";

import { DISPLAY_MODE_FULL_BREAKDOWN } from "../CreateDocumentModal/constants";

import * as actions from "./create-proforma-invoice.actions";

const initialState = {
  isOpen: false,
  invoiceDate: null,
  activeTab: "actual",
  displayMode: DISPLAY_MODE_FULL_BREAKDOWN,
  lastGeneratedDisplayMode: null,
  oneLinerDescription: "",
  groupedLabourLabel: "",
  groupedMaterialsLabel: "",
  invoiceDisplayModeStatus: null,
};

export default createReducer(initialState, {
  [actions.setIsOpen]: createSetter("isOpen"),
  [actions.setInvoiceDate]: createSetter("invoiceDate"),
  [actions.setActiveTab]: createSetter("activeTab"),
  [actions.setDisplayMode]: createSetter("displayMode"),
  [actions.setLastGeneratedDisplayMode]: createSetter("lastGeneratedDisplayMode"),
  [actions.setOneLinerDescription]: createSetter("oneLinerDescription"),
  [actions.setGroupedLabourLabel]: createSetter("groupedLabourLabel"),
  [actions.setGroupedMaterialsLabel]: createSetter("groupedMaterialsLabel"),
  [actions.setInvoiceDisplayModeStatus]: createSetter("invoiceDisplayModeStatus"),
  [actions.reset]: () => ({ ...initialState, invoiceDate: null }),
});
